/**
 * Seed gallery entries — intentionally empty.
 *
 * The Our Work gallery now renders entirely from the published submissions
 * manifest. Demo/starter photos that previously lived in this file are
 * uploaded as a "Test User" submission via the admin dashboard so they
 * flow through the same publish pipeline as real client work.
 *
 * If you ever need a static fallback (e.g. while the manifest URL is
 * unreachable), add entries here in the shape:
 *   { service: 'garden' | 'flowers', category, type: 'before' | 'after',
 *     url, caption, alt }
 */
export const SEED_IMAGES = [];
